import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CameraService, CAMERA_MODEL, TCameraModel } from '@monorepo/services';
import {
  IDefectList,
  IOperationsList,
  TBctxHeaderItem,
  TDepartmentWiseOperationListAndGenericIssueMap,
  TDeptWiseMultiSelectList,
  THandleIssueOperationSelectionList,
  TOperationIssueAndMarkedLocations,
  TSelectedOperationOrRejectReasonList,
  TUpdateFilteredListsV3,
} from '@monorepo/types';
import { BCTXComputationHelper, EventUtil, InputAppAPIHelperUtil } from '@monorepo/utils';
import { FilterMasterdataListComponent } from '../filter-masterdata-list/filter-masterdata-list.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-operation-selection-v3',
  templateUrl: './operation-selection-v3.component.html',
  styleUrls: ['./operation-selection-v3.component.scss'],
})
export class OperationSelectionV3Component implements OnChanges {
  @Input() isRecentDefectiveSelection: boolean = false;
  @Input() bctxHeader: TBctxHeaderItem[] = [];
  @Input() departments: string[] = [];
  @Input() recentDefectiveList: TSelectedOperationOrRejectReasonList = [];
  @Input() departmentWiseOperationListAndGenericIssueMap!: TDepartmentWiseOperationListAndGenericIssueMap;
  @Input() selectedOperationList: TSelectedOperationOrRejectReasonList = [];

  @Output() cancel = new EventEmitter<'CANCEL'>();
  @Output() clearAll = new EventEmitter<'CLEAR_ALL'>();
  @Output() next = new EventEmitter<IOperationsList[] | TOperationIssueAndMarkedLocations[]>();
  @Output() onViewAll = new EventEmitter<TUpdateFilteredListsV3>();

  CAMERA_MODEL = CAMERA_MODEL.identity(EventUtil.getBucketIdFromUniqueEventId(BCTXComputationHelper.getUniqueVId()));
  showShowingDefectsOption: boolean = false;
  isShowShowingDefectsChecked: boolean = false;
  deptWiseMultiSelectList: TDeptWiseMultiSelectList = {};

  constructor(
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,
    private modalCtrl: ModalController,
    private translate: TranslateService,
  ) {}

  ngOnChanges() {
    if (!this.isRecentDefectiveSelection) {
      this.deptWiseMultiSelectList = {};
      this.showShowingDefectsOption = Object.keys(this.departmentWiseOperationListAndGenericIssueMap).length > 1;
      this.getDeptWiseMultiSelectList();
    }
  }

  showShowingDefectsChange() {
    console.log('isShowShowingDefectsChecked changed..', this.isShowShowingDefectsChecked);
  }

  getDeptWiseMultiSelectList() {
    Object.keys(this.departmentWiseOperationListAndGenericIssueMap).map((department) => {
      this.departmentWiseOperationListAndGenericIssueMap[department].operationsList.map((operation) => {
        if (this.deptWiseMultiSelectList && this.deptWiseMultiSelectList[department]) {
          this.deptWiseMultiSelectList[department].operationList.push({
            id: operation.id,
            name: operation.name,
            category_id: operation.id,
            group_id: [],
            group_name: '',
            department: department,
          });
        } else {
          this.deptWiseMultiSelectList[department] = {
            operationList: [
              {
                id: operation.id,
                name: operation.name,
                category_id: operation.id,
                group_id: [],
                group_name: '',
                department: department,
              },
            ],
            allOperationList: [],
            toggleHandler: false,
            selectedOperationList: [],
          };
        }
      });

      if (this.departmentWiseOperationListAndGenericIssueMap[department].operationsList.length === 0) {
        if (this.deptWiseMultiSelectList && this.deptWiseMultiSelectList[department]) {
          this.deptWiseMultiSelectList[department].operationList = [];
        } else {
          this.deptWiseMultiSelectList[department] = {
            operationList: [],
            allOperationList: [],
            toggleHandler: false,
            selectedOperationList: [],
          };
        }
      }
      this.departmentWiseOperationListAndGenericIssueMap[department].allOperationList.map((operation) => {
        this.deptWiseMultiSelectList[department].allOperationList.push({
          id: operation.id,
          name: operation.name,
          category_id: '',
          group_id: [],
          group_name: '',
          department: department,
        });
      });
    });
  }

  toggleDropdown(department: string) {
    this.deptWiseMultiSelectList[department].toggleHandler = !this.deptWiseMultiSelectList[department].toggleHandler;
  }

  handleOperationSelection(selectedList: THandleIssueOperationSelectionList, department: string) {
    if (this.isRecentDefectiveSelection) {
      this.selectedOperationList = selectedList as TOperationIssueAndMarkedLocations[];
    } else {
      this.deptWiseMultiSelectList[department].selectedOperationList = selectedList as IOperationsList[];
      const selectedOperationsList: IOperationsList[] = [];

      this.departments.map((department) => {
        this.deptWiseMultiSelectList[department].selectedOperationList.map((operation) => {
          selectedOperationsList.push(operation);
        });
      });
      this.selectedOperationList = selectedOperationsList;
    }
  }

  async onViewAllClick(department: string) {
    let allOperationList = this.deptWiseMultiSelectList[department].allOperationList;
    let preSelectedList = this.deptWiseMultiSelectList[department].operationList;

    const modal = await this.modalCtrl.create({
      component: FilterMasterdataListComponent,
      componentProps: {
        type: 'OPERATION_OR_DEFECT',
        lists: allOperationList,
        preSelectedLists: preSelectedList,
        title: 'operation_or_reject_reason_selection.listOfOperations',
      },
      cssClass: 'm-modal_reject_flow_component',
      backdropDismiss: false,
    });
    await modal.present();
    modal.onDidDismiss().then((res) => {
      if (res.data) {
        const t = res.data as IOperationsList[] | IDefectList[];
        const filteredList: string[] = t.map((x) => x.name);
        const updatedFilteredLists: TUpdateFilteredListsV3 = {
          type: 'FILTERED_OPERATIONS_LIST',
          department: department,
          list: filteredList,
        };

        this.onViewAll.emit(updatedFilteredLists);
      }
    });
  }

  handleClearAll() {
    console.log('[Clear All clicked]');
    this.selectedOperationList = [];
    this.clearAll.emit('CLEAR_ALL');
  }

  handleCancel() {
    this.cancel.emit('CANCEL');
  }

  handleNextOrDone() {
    if (this.selectedOperationList.length === 0)
      this.inputAppAPIHelperUtil.showPopup(
        this.translate.instant('input_app_common.alert'),
        this.translate.instant('operation_or_reject_reason_selection.alertMessage'),
      );
    else {
      console.log('[FINAL_SELECTED_OPERATION_OR_ISSUE_LIST]', this.selectedOperationList);
      if (this.isRecentDefectiveSelection) {
        this.next.emit(this.selectedOperationList as TOperationIssueAndMarkedLocations[]);
      } else {
        this.next.emit(this.selectedOperationList as IOperationsList[]);
      }
    }
  }
}
